import React, { useEffect, useState } from 'react';
import { CHECKOUT_URL } from './CTAButton';
import { PRICE_NOW } from './salesData';
import { trackInitiateCheckout } from '../utils/metaPixel';

/**
 * Barra de compra fija en mobile. Aparece cuando el usuario deja atrás el hero
 * y se oculta al llegar al footer. Usa el mismo checkout que el resto de CTAs.
 */
export function StickyCta() {
  const [pastHero, setPastHero] = useState(false);
  const [atFooter, setAtFooter] = useState(false);
  useEffect(() => {
    const hero = document.getElementById('hero');
    const footer = document.getElementById('site-footer');
    if (typeof IntersectionObserver === 'undefined') return;
    const observers: IntersectionObserver[] = [];
    if (hero) {
      const heroObserver = new IntersectionObserver(([entry]) => setPastHero(!entry.isIntersecting), {
        rootMargin: '-40px 0px 0px 0px'
      });
      heroObserver.observe(hero);
      observers.push(heroObserver);
    }
    if (footer) {
      const footerObserver = new IntersectionObserver(([entry]) => setAtFooter(entry.isIntersecting));
      footerObserver.observe(footer);
      observers.push(footerObserver);
    }
    return () => observers.forEach(o => o.disconnect());
  }, []);
  const visible = pastHero && !atFooter;
  return <div className={`fixed inset-x-0 bottom-0 z-50 border-t border-rose/10 bg-white/95 backdrop-blur transition-transform duration-300 lg:hidden ${visible ? 'translate-y-0' : 'translate-y-full'}`} style={{
    paddingBottom: 'env(safe-area-inset-bottom)'
  }} aria-hidden={!visible} data-id="element-187" data-mp="c58oopmwbapj">
      <div className="mx-auto flex max-w-xl items-center justify-between gap-3 px-4 py-2.5" data-id="element-188" data-mp="zv2wutw9sb3g">
        <div className="min-w-0" data-id="element-189" data-mp="uuyjhcqnrwhg">
          <p className="truncate text-[0.7rem] font-semibold uppercase tracking-wide text-ink/60" data-id="element-190" data-mp="uvztrezuoey4">
            Estética Digital PRO
          </p>
          <p className="font-sans text-lg font-extrabold leading-tight tracking-tight text-ink tabular-nums" data-id="element-191" data-mp="2wmtgqnc63yg5">
            {PRICE_NOW}
          </p>
        </div>
        <a href={CHECKOUT_URL} onClick={() => trackInitiateCheckout()} tabIndex={visible ? 0 : -1} className="shrink-0 rounded-full bg-gradient-to-r from-[#4656f5] via-[#8a55df] to-[#ff7396] px-6 py-2.5 text-sm font-bold uppercase tracking-wide text-white shadow-md shadow-indigo-500/25 transition-all hover:brightness-105 focus:outline-none focus-visible:ring-4 focus-visible:ring-indigo-300/50" data-id="element-192" data-mp="10l9m73yuhd75">
          Comprar
        </a>
      </div>
    </div>;
}